module.exports = __webpack_public_path__ + "img/128.7.a16d1177.png";